import React from 'react';
import { useParams } from 'react-router-dom';
import { usePortalQuery } from '../../hooks/usePortalQuery';
import { listAudit } from '../../lib/portalApi';
import { orgName } from '../../context/PortalOrg';
import { PageHeader } from '../../components/portal/PageHeader';
import { EmptyState, QueryState } from '../../components/portal/QueryState';
import { describeAudit, displayName, formatDateTime } from '../../utils/portalFormat';
export function PortalAudit() {
  const {
    orgId = ''
  } = useParams<{
    orgId: string;
  }>();
  const [page, setPage] = React.useState(1);
  const {
    data,
    loading,
    error
  } = usePortalQuery(() => listAudit(orgId, {
    page
  }), [orgId, page]);
  return <div data-id="element-2836" data-mp="1s049ta7vwyaj">
      <PageHeader eyebrow={orgName(orgId)} title="Audit log" description="Who did what, and when: uploads, downloads, invitations, role changes and payments. Entries cannot be edited or removed." data-id="element-2837" data-mp="1s0clwzw6nzko" />
      <div className="mt-6" data-id="element-2838" data-mp="107vh8hf70q38">
        <QueryState loading={loading} error={error} data-id="element-2839" data-mp="108of0sw6c598">
          {data && data.data.length === 0 ? <EmptyState title="Nothing recorded yet" data-id="element-2840" data-mp="3haaxnuah9z0r" /> : data && <>
                <ol className="divide-y divide-line border-y border-line" data-id="element-2841" data-mp="3m7b0lwc16lnn">
                  {data.data.map(entry => <li key={entry.id} className="grid gap-1 py-4 sm:grid-cols-[170px_1fr] sm:gap-6" data-id="element-2842" data-mp="3vz7981bqtu64">
                      <time dateTime={entry.createdAt} className="text-[13px] text-muted" data-id="element-2843" data-mp="2yc8azm5eke64">
                        {formatDateTime(entry.createdAt)}
                      </time>
                      <p className="text-[14px] text-body" data-id="element-2844" data-mp="389w7ohmkjvqx">
                        <span className="text-ink" data-id="element-2845" data-mp="388bdit462etl">{entry.user ? displayName(entry.user) : 'System'}</span>
                        {entry.user?.isInternal && <span className="text-gold" data-id="element-2846" data-mp="3d6mpb9e0uzeg">, Cavalla</span>} {describeAudit(entry.action, entry.metadata)}
                      </p>
                    </li>)}
                </ol>
                {data.meta.totalPages > 1 && <nav aria-label="Pagination" className="mt-5 flex items-center justify-between text-[14px] text-muted" data-id="element-2847" data-mp="2oklh3kyp2464">
                    <span data-id="element-2848" data-mp="2jmk1xb4e2ozx">
                      Page {data.meta.page} of {data.meta.totalPages}
                    </span>
                    <span className="flex gap-2" data-id="element-2849" data-mp="2tkzs9bvldu8d">
                      <button type="button" disabled={page <= 1} onClick={() => setPage(page - 1)} className="rounded-sm border border-line px-3 py-1.5 text-ink disabled:opacity-40" data-id="element-2850" data-mp="2tmavnal4kzyy">
                        Newer
                      </button>
                      <button type="button" disabled={page >= data.meta.totalPages} onClick={() => setPage(page + 1)} className="rounded-sm border border-line px-3 py-1.5 text-ink disabled:opacity-40" data-id="element-2851" data-mp="20uhhrpsjgqkx">
                        Older
                      </button>
                    </span>
                  </nav>}
              </>}
        </QueryState>
      </div>
    </div>;
}